import apiService from './apiService';

export interface MasterPlantCodePayload {
  title: string;
}

export const getMasterPlantCodes = async () => {
  const response = await apiService.get('/plantcodes');
  return response.data;
};

export const createMasterPlantCode = async (payload: MasterPlantCodePayload) => {
  const response = await apiService.post('/plant-codes', payload);
  return response.data?.data ?? response.data;
};

export const updateMasterPlantCode = async (id: number, payload: MasterPlantCodePayload) => {
  const response = await apiService.put(`/plant-codes/${id}`, payload);
  return response.data?.data ?? response.data;
};

export const deleteMasterPlantCode = async (id: number) => {
  const response = await apiService.delete(`/plant-codes/${id}`);
  return response.data;
};
